import React, { Component } from 'react';
import { Tree, Select, Spin, notification, Button } from 'antd';
import api from '../../utils/api';
import { post, get } from '../../utils/http';

const { Option } = Select;

class RoleManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleId: "1",
            treeData: [],
            flag1: false,
            flag2: false,
            checkedKeys: [],
            // expandKeys: []
        }
    }


    handleChange = (value) => {
        this.setState({ roleId: value }, () => {
            this.handleSearchRoleMenu()
        })
    }

    handleSearchRoleMenu = () => {
        this.setState({ flag2: true })
        let searchData = new FormData();
        searchData.append("roleId", this.state.roleId);
        var _this = this;
        post(api.queryRoleMenu, searchData).then(function (response) {
            const c = response.map((res) => {
                return res.menuId;
            })
            _this.setState({ flag2: false, checkedKeys: c })
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to get role infomation.',
            });
            _this.setState({ flag2: false })
        })
    }

    // handleExpand = (expandKeys, info) => {
    //     console.log("info",info)
    //     // this.setState({expandKeys:expandKeys},(()=>{
    //     //     console.log('expandKeys',this.state.expandKeys)
    //     // }))
    // }

    // handleSelect = (selectedKey, info) => {
    //     let keys = this.state.expandKeys;
    //     console.log("Keys",keys);
    //     console.log('selectedKey',selectedKey);

    //     console.log(keys.indexOf(selectedKey[0]))
    //     if(keys.indexOf(selectedKey[0])!==-1){
    //         keys.pop(selectedKey[0])
    //     }else(
    //         keys.push(selectedKey[0])
    //     )

    //     console.log(info)
    //     this.handleExpand(keys)
    // }

    handleCheck = (checkedKeys, info) => {
        this.setState({ checkedKeys: checkedKeys })
    }

    handleSubmit = () => {
        this.setState({ flag2: true })
        var _this = this;
        var subData = { roleId: this.state.roleId, menuId: this.state.checkedKeys }
        post(api.updateRoleMenuList, subData).then(function (response) {
            notification['success']({
                message: 'Modify successfully .',
            });
            _this.setState({ flag2: false })
        }).catch(function (error) {
            console.log("@error", error)
            notification['error']({
                message: 'Fail to update.',
            });
            _this.setState({ flag2: false })

        })
    }

    componentDidMount() {
        this.setState({ flag1: true });
        var _this = this;
        post(api.queryALLMenu).then(function (response) {
            const menus = [];
            response.map((m) => {
                if (m.children) {
                    const ch = []
                    m.children.map((mc) => {
                        ch.push({ title: mc.menuName, key: mc.menuId })
                    })
                    menus.push({ title: m.menuName, key: m.menuId, children: ch, checkable: false });
                } else {
                    menus.push({ title: m.menuName, key: m.menuId, checkable: false })
                }
            })

            _this.setState({ treeData: menus, flag1: false })
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to get menu data.',
            });
            _this.setState({ flag1: false })
        })
        _this.handleSearchRoleMenu();

    }



    render() {
        return (<div style={{ margin: '50px', backgroundColor: "white", padding: "20px" }}>

            <Spin spinning={this.state.flag1 || this.state.flag2}>
                <div style={{ backgroundColor: "#fff", padding: "20px" }}>
                    <span style={{ height: "38px", lineHeight: "38px", fontSize: "22px", marginRight: "15px" }}>Layer:</span>
                    <Select size="large" value={this.state.roleId} onChange={this.handleChange} style={{ width: 100 }}>
                        <Option key="1">L1</Option>
                        <Option key="2">L2</Option>
                        <Option key="3">L3</Option>
                        <Option key="4">L4</Option>
                        <Option key="5">L5</Option>
                        <Option key="6">L6</Option>
                    </Select>

                </div>
                <div>
                    <Tree
                        selectable={false}
                        // selectedKeys={[]}
                        // expandKeys={this.state.expandKeys}
                        // onExpand={this.handleExpand}
                        // onSelect={this.handleSelect}
                        // autoExpandParent={true}
                        checkedKeys={this.state.checkedKeys}
                        onCheck={this.handleCheck}
                        checkable={true}
                        treeData={this.state.treeData}
                        style={{ padding: "20px", fontSize: "20px", maringBottom: "20px" }}
                    />
                </div>

                <Button onClick={this.handleSubmit} style={{ marginTop: "20px", marginLeft: "75px" }} type="primary">Submit</Button>

            </Spin>
        </div>
        );
    }
}

export default RoleManagement;